const STEPS = [
  {
    n: "01",
    title: "Envie a fotografia",
    body: "Uma imagem do seu jardim, tirada do telemóvel. Quanto mais ampla a perspectiva, mais precisa a simulação.",
  },
  {
    n: "02",
    title: "Recebe a simulação",
    body: "Em menos de 24 horas, mesmo aos fins de semana, enviamos uma visualização fotorrealista com a piscina integrada no seu espaço, em alta definição.",
  },
  {
    n: "03",
    title: "Fala com um instalador",
    body: "Se quiser avançar, apresentamos o parceiro acreditado da sua zona. Orçamento directo, sem intermediários escondidos.",
  },
];

export default function Process() {
  return (
    <section
      id="processo"
      data-testid="process-section"
      className="border-b border-rule bg-sand"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-20 md:py-32">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4 reveal">
            <div className="overline text-ink/60">Processo editorial</div>
            <h2 className="font-serif font-light text-3xl md:text-5xl lg:text-6xl mt-4 tracking-tight leading-[1.05] text-ink">
              Três etapas. Sem fricção.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6 reveal">
            <p className="text-base md:text-lg text-ink/70 font-light max-w-xl">
              Trabalhamos como um estúdio de arquitectura. Pequeno, metódico, obsessivo com o detalhe. Não há call centers, não há formulários intermitentes. Um processo curto e um resultado que vale a espera.
            </p>
          </div>
        </div>

        <ol className="divide-y divide-rule border-t border-b border-rule">
          {STEPS.map((s) => (
            <li
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="grid grid-cols-12 gap-4 md:gap-10 py-10 md:py-14 group reveal"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="number-serif text-6xl md:text-8xl text-pool-deep block transition-transform duration-700 group-hover:translate-x-2">
                  {s.n}
                </span>
              </div>
              <div className="col-span-9 md:col-span-5">
                <h3 className="font-serif text-2xl md:text-3xl text-ink leading-snug">{s.title}</h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="text-base md:text-lg text-ink/70 font-light leading-relaxed">{s.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
